import getShortName from './Data/User/getShortName'
import getShortDate from './getShortDate'
import that from './translationHelper'

const getPostTitle = (user, date) => that.context.translate('Post - {user} - {date}', { user: getShortName(user), date: getShortDate(date) })

export default getPostTitle



// WEBPACK FOOTER //
// ./src/utilities/getPostTitle.js